import script from "./DeadlineCameras.vue?vue&type=script&setup=true&lang=js"
export * from "./DeadlineCameras.vue?vue&type=script&setup=true&lang=js"

import "./DeadlineCameras.vue?vue&type=style&index=0&id=4ee7c4fb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ee7c4fb"]])

export default __exports__